<script>
  import { onMount } from "svelte";
  import { Article, Table, Switch, Modal, Breadcrumb } from "spaper";
  import { navigate } from "svelte-routing";
  import { getAdoptionRequests, updateAdoptionRequest, deleteAdoptionRequest, showErrorThenCallback } from "../utils/utils";
  import { strings } from "../constants/strings";
  import HeaderMini from "../components/HeaderMini.svelte";
  import ActionButton from "../components/ActionButton.svelte";
  import Footer from "../components/Footer.svelte";

  export let id;

  let adoptionRequestInfo = {
    adoptable: {
      name: "Adoptable",
      image: ""
    },
    date:"",
    name: "",
    phone: "",
    email: "",
    location: "",
    comments: "",
    attended: false,
    had_pets: true,
    comments: ""
  };
  let tableData = [];
  let attended = false;

  $: breadcrumbPath = [
    {
      text: "Solicitudes",
      href: "/_adoptionrequests"
    },
    {
      text: adoptionRequestInfo.adoptable.name,
      href: `/_adoptionrequest/${id}`
    }
  ];

  const tableColumns = [
    {field: "name", label: "Solicitante"},
    {field: "phone", label: "Teléfono"},
    {field: "email", label: "Correo"},
    {field: "location", label: "Ubicación", content: x => strings.locations[x]},
    {field: "date", label: "Fecha", content: x => new Date(x).toDateString()}
  ];

  const updateAttended = async () => {
    const resp = await updateAdoptionRequest(id, attended);
    adoptionRequestInfo.attended = resp.attended;
  };

  const showModal = () => activeModal = true;

  const deleteRequest = async () => {
    try {
      activeModal = false;
      await deleteAdoptionRequest(id);
      navigate("/_adoptionrequests");
    } catch (error) {
      showErrorThenCallback(error, () => { navigate("/_admin") });
    }
  };
  
  onMount(async () => {
    try {
      adoptionRequestInfo = await getAdoptionRequests(`_id=${id}`);
      tableData = [adoptionRequestInfo];
      attended = adoptionRequestInfo.attended;
    } catch (errorMessage) {
      showErrorThenCallback(errorMessage, () => { navigate("/_admin") });
    }
  });

  $: hasChanged = adoptionRequestInfo.attended != attended;
  let activeModal = false;
</script>

<HeaderMini />
<Breadcrumb items={breadcrumbPath} />
<div class="main-content">
  <Article title="Solicitud de Adopción para {adoptionRequestInfo.adoptable.name}">
    <p slot="meta">
      <Table data={tableData} columns={tableColumns} />
    </p>
    <p>
      <img src={`${adoptionRequestInfo.adoptable.image}?x=${new Date()}`} alt="{adoptionRequestInfo.adoptable.name} image" class="float-left" />
      <b>Motivo:</b><br />
      {adoptionRequestInfo.comments}
      <br />
      <br />
      <b>
        Ha tenido mascotas antes: 
        {adoptionRequestInfo.had_pets ? "Sí" : "No"}
      </b>
    </p>
    <br />
    <br />
    <div class="form-group">
      <b>Seguimiento</b>
      <br />
      <Switch bind:checked={attended}>
        {attended ? "En seguimiento" : "Pendiente"}
      </Switch>
      <br />
      {#if hasChanged}
        <ActionButton klass="btn-success" action={updateAttended} text="Actualizar Estatus"/>
      {/if}
      <button class="btn-danger" on:click={showModal}>Borrar</button>
      <Modal title="Borrar" closeBtnText="No" bind:active={activeModal}>
        ¿Relamente desea borrar esta solicitud?
        <br />
        <button class="btn-danger" on:click={deleteRequest}>Sí, borrar</button>
      </Modal>
    </div>
  </Article>
</div>
<Footer />

<style>
  img {
    display: block;
    margin: auto;
    width: 300px;
  }
  .main-content {
    margin-bottom: 2vh;
  }
</style>